'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _string_utility = require('../../../packages/common-utilities/src/string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _ramda = require('ramda');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Expenses = function (_React$PureComponent) {
    _inherits(Expenses, _React$PureComponent);

    function Expenses(props) {
        _classCallCheck(this, Expenses);

        return _possibleConstructorReturn(this, (Expenses.__proto__ || Object.getPrototypeOf(Expenses)).call(this, props));
    }

    _createClass(Expenses, [{
        key: 'sumManagementFeesAndCosts',
        value: function sumManagementFeesAndCosts() {
            var validValues = [this.props.expenses.managementFee, this.props.expenses.expenseRecoveries, this.props.expenses.otherIndirectCosts].filter(function (n) {
                return !isNaN(n);
            }).filter(function (n) {
                return n !== null;
            });
            if (validValues.length === 0) {
                return '-';
            }
            return _number_utility2.default.formatToPercentWith2FixedDecimals((0, _ramda.sum)(validValues));
        }
    }, {
        key: 'renderExpense',
        value: function renderExpense() {
            var leftDataPointLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _string_utility2.default.renderFormattedLabel("Gross", "label-for-gross-expenses");
            var leftDataTestId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "gross-expense";
            var leftDataPointValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _number_utility2.default.formatToPercentWith2FixedDecimals(this.props.expenses.grossExpense);
            var rightDataPointLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _string_utility2.default.renderFormattedLabel("Net", "label-for-net-expenses");
            var rightDataTestId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "net-expense";
            var rightDataPointValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : _number_utility2.default.formatToPercentWith2FixedDecimals(this.props.expenses.netExpense);

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { 'data-testid': 'header-stats-expenses',
                            className: 'tag font-black-variant' },
                        _string_utility2.default.renderFormattedLabel("EXPENSES", "label-for-expenses")
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'font-slate-grey disclaimer' },
                        '\xA0'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'display-inline-block margin-top-5 margin-right-10 ' },
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'display-block disclaimer font-black-variant' },
                        leftDataPointLabel
                    ),
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'display-block ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "tag", "sub-header-2") + ' font-black-variant',
                            'data-testid': leftDataTestId },
                        leftDataPointValue
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'display-inline-block margin-top-5 margin-right-10' },
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'display-block disclaimer font-black-variant' },
                        rightDataPointLabel
                    ),
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'display-block ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "tag", "sub-header-2") + ' font-black-variant',
                            'data-testid': rightDataTestId },
                        rightDataPointValue
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "QUICK_STAT_EXPENSE_MANAGEMENT_FEE_MER")) {
                return this.renderExpense(_string_utility2.default.renderFormattedLabel("Management Fee", "pdp-performance-fees-investment-management"), "management-fee", _number_utility2.default.formatToPercentWith2FixedDecimals(this.props.expenses.investmentManagement), _string_utility2.default.renderFormattedLabel("MER", "pdp-performance-fees-mer"), "mer", _number_utility2.default.formatToPercentWith2FixedDecimals(this.props.expenses.mer));
            }
            if (!_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "QUICK_STAT_MANAGEMENT_COSTS")) {
                return this.renderExpense();
            } else {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { 'data-testid': 'header-stats-expenses',
                                className: 'tag font-black-variant' },
                            _string_utility2.default.renderFormattedLabel("MANAGEMENT FEES AND COSTS", "label-for-mgmt-costs")
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'font-slate-grey disclaimer' },
                            '\xA0'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'display-inline-block margin-top-5 margin-right-10' },
                        _react2.default.createElement(
                            'span',
                            { className: 'display-block disclaimer font-black-variant' },
                            '\xA0'
                        ),
                        _react2.default.createElement(
                            'span',
                            {
                                className: 'display-block ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "tag", "sub-header-2") + ' font-black-variant',
                                'data-testid': 'mgmt-fee-expense' },
                            this.sumManagementFeesAndCosts()
                        )
                    )
                );
            }
        }
    }]);

    return Expenses;
}(_react2.default.PureComponent);

exports.default = Expenses;